import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema } from '@/core/components';

import { defaultTextValues, textSchema } from '../../Text/model/TextSchema';

export const bookSchema = textSchema.extend({
  isbn: z.object({
    printCode: z.string().nullable(),
    onlineCode: z.string().nullable(),
  }),
  authors: z.array(authorSchema).min(1),
  type: z.string(),
});

export const defaultBookValues: DefaultValues<BookSchema> = {
  authors: [],
  isbn: {
    printCode: '',
    onlineCode: '',
  },
  type: 'BOOK',
  ...defaultTextValues,
};

export type BookSchema = z.infer<typeof bookSchema>;
